module.exports = __webpack_public_path__ + "img/logo-perfil.beab7730.png";